import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { GuestModel, AuthModel } from '@models';
import { AuthServices, AlertServices } from '@services';

@Component({
    selector: 'app-login-page',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})

export class LoginComponent {

    AllowRegistration = false;
    HiddenPassword = true;

    ProjectLogo = '../../assets/img/gallery/login.png'

    AuthenticationForm: FormGroup;

    Guest: GuestModel = new GuestModel({});
    isLoading = false;


    RescueLine_OLD_URL = false;
    AppShowThisSection = true;


    //TODO : SAME PROCESS AS DISY MOBILE APP
    //
    // 1. On Login Request show loading
    //    POST:      Username and Password
    //    Response : AuthToken ( OTP is Required)
    //    Response : AuthToken & AuthSalt ( NO OTP) 
    // 2. When is Authenticated and Not OTP ( authorization ) then Apply User Settings Show Loading User Profile
    // 3. When Done and not OTP then Goto App Main Route ( Dashboard )
    // 4. If OTP then 2-3 will be executed on OTP process
    //
    // OR After Login Goto OTP and Then IF OTP is not Required then Redirect User to App
    // Settings will be applied on OTP Section

    constructor(
        @Inject('AuthServices') private _authServices: AuthServices,
        @Inject('AlertServices') private _alertServices: AlertServices,
        //public translate: TranslateService,
        private router: Router,
        private _activatedRoute: ActivatedRoute,
        private formBuilder: FormBuilder,
    ) {

        //Get the Page if redirected to login ( used for redirecturl )
        // CAUTION : this causes issue on verification. redirect it to login 
        // this.router.events.subscribe((event) => {
        //     if (event instanceof NavigationEnd) {
        //        if (event.urlAfterRedirects === '/login') {
        //         localStorage.setItem('RedirectURL', event.url);
        //        }
               
        //     }
        // });


    }

    EnterKeyTrigger(_event: KeyboardEvent) {
        if (_event.keyCode === 13) {
            this.onSignIn();
            _event.stopPropagation();
            _event.preventDefault();
        }
    }

    ngOnInit() {

        //Direct Login using Parameters
        const queryParams = this._activatedRoute.snapshot['queryParams'];
        let _auth = new AuthModel
        _auth.AuthToken = queryParams['AuthToken']
        _auth.AuthSalt = queryParams['AuthSalt']

        if (_auth.AuthToken && _auth.AuthSalt) {
            this._authServices._postAuthorization(_auth)
        }


        this.CheckHostOrigin();

        //Check if webservice is running... If not then goto Maintenance Page
        //Discuss this with Odysseas
        //this.CheckHealthStatus();

        //this._authService.ClearLocalStorage();
        this.isLoading = false;

        this.AuthenticationForm = this.formBuilder.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]]
        });

        if (this._authServices.isAuthorized()) { this._authServices._startApp() }

    }

    onSignIn() {

        if (this.AuthenticationForm.valid) {

            this.isLoading = true;

            this.Guest.Username = this.AuthenticationForm.value['username'];
            this.Guest.Password = this.AuthenticationForm.value['password'];

            this._authServices.Login(this.Guest).subscribe(
                () => {
                    this.isLoading = false;
                }, (_error) => {
                    this.isLoading = false;
                    //WHEN API SERVER NOT RESPONDING
                    //TODO IMPLEMENT THIS TO ALL REQUESTs
                    if (_error.status === 0) { this.router.navigate(['maintenance']) }

                    const _ErrorResponse = JSON.parse(_error._body)
                    this._alertServices.ShowMessage('error', 'app.trn-error-title', _ErrorResponse.ErrorMessage);
                });
        }
    }


    CheckHealthStatus() {
        let healthStatus: boolean = false;
        this.router.navigate(['maintenance'])
    }

    // On Forgot password link click
    onForgotPassword() {
        this.router.navigate(['recovery'], {});
    }

    onChangeLanguage() {
        // this.translate.use('gr');
    }


    CheckHostOrigin() {

        // Find other ways ??????

        // if (location.hostname.toLowerCase().indexOf('localhost') > -1) {
        //     this._socket.Initialize_Socket_Connection()
        // }

        // if (location.hostname.toLowerCase().indexOf('epos.app.cspcom.com') > -1 || location.hostname.toLowerCase().indexOf('epos.parco.com.cy') > -1 ) {        
        //     this._socket.Initialize_Socket_Connection()
        // }

        if (location.hostname.toLowerCase().indexOf('cpp.app.cspcom.com') > -1) {
            this.AllowRegistration = true;
        }

        if (location.hostname.toLowerCase().indexOf('accidentcare.rescueline.com.cy') > -1) {
            this.ProjectLogo = '../../assets/app/rl/RescueLine_Logo.png'
            this.RescueLine_OLD_URL = true;
            this.AppShowThisSection = false;
        }



    }


    onRegistration() {
        this.router.navigate(['/register'], {});

        // if (location.hostname.toLowerCase().indexOf('app.cpp.org.cy') > -1) {
        //     this.router.navigate(['/register'], {});
        // }

    }


    OpenRescueLineURL() {
        window.open("https://old-accidentcare.rescueline.com.cy/");
    }




}
